import type { SVGProps } from 'react';
import * as React from 'react';

const ChartBarProgressIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <g id="outline/chart-bar-progress">
      <g id="icon">
        <path
          d="M7.5 13.501C7.91421 13.501 8.25 13.8368 8.25 14.251V16.501C8.24953 16.9148 7.91392 17.251 7.5 17.251C7.08608 17.251 6.75047 16.9148 6.75 16.501V14.251C6.75 13.8368 7.08579 13.501 7.5 13.501Z"
          fill="currentColor"
        />
        <path
          d="M10.5 12.251C10.9142 12.251 11.25 12.5868 11.25 13.001V16.501C11.2495 16.9148 10.9139 17.251 10.5 17.251C10.0861 17.251 9.75047 16.9148 9.75 16.501V13.001C9.75 12.5868 10.0858 12.251 10.5 12.251Z"
          fill="currentColor"
        />
        <path
          d="M13.5 10.751C13.9142 10.751 14.25 11.0868 14.25 11.501V16.501C14.2495 16.9148 13.9139 17.251 13.5 17.251C13.0861 17.251 12.7505 16.9148 12.75 16.501V11.501C12.75 11.0868 13.0858 10.751 13.5 10.751Z"
          fill="currentColor"
        />
        <path
          d="M16.5 9.00098C16.9142 9.00098 17.25 9.33676 17.25 9.75098V16.501C17.2495 16.9148 16.9139 17.251 16.5 17.251C16.0861 17.251 15.7505 16.9148 15.75 16.501V9.75098C15.75 9.33676 16.0858 9.00098 16.5 9.00098Z"
          fill="currentColor"
        />
        <path
          d="M17 5C17.2761 5.00008 17.5 5.22391 17.5 5.5V7.5C17.5 7.77609 17.2761 7.99992 17 8C16.7239 8 16.5 7.77614 16.5 7.5V6.73438C13.2635 9.94316 10.2416 11.3489 6.58691 11.9922C6.31505 12.04 6.05582 11.8587 6.00781 11.5869C5.95996 11.315 6.14128 11.0558 6.41309 11.0078C9.86854 10.3996 12.7153 9.08793 15.8213 6H15C14.7239 6 14.5 5.77614 14.5 5.5C14.5 5.22386 14.7239 5 15 5H17Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18 2.39453C19.6569 2.39453 21 3.73865 21 5.39551V17.3955C20.9997 19.0521 19.6567 20.3955 18 20.3955H6C4.34331 20.3955 3.00026 19.0521 3 17.3955V5.39551C3 3.73865 4.34315 2.39453 6 2.39453H18ZM6 3.89551C5.17157 3.89551 4.5 4.56708 4.5 5.39551V17.3955C4.50026 18.2237 5.17174 18.8955 6 18.8955H18C18.8283 18.8955 19.4997 18.2237 19.5 17.3955V5.39551C19.5 4.56708 18.8284 3.89551 18 3.89551H6Z"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
);
export default ChartBarProgressIcon;
